import { render, staticRenderFns } from "./pre-registration.vue?vue&type=template&id=3c202ff9&scoped=true"
import script from "./pre-registration.vue?vue&type=script&lang=js"
export * from "./pre-registration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c202ff9",
  null
  
)

export default component.exports